module.exports = __webpack_public_path__ + "img/logo-inocencio.b8b2c3de.png";